export default __webpack_public_path__ + "static/media/historyTicket.07a79145.png";